const zoomModalConstants = {
  ZOOM_MODAL_DESTROY: "ZOOM_MODAL_DESTROY",
  ZOOM_MODAL_UPDATE_SLIDE: "ZOOM_MODAL_UPDATE_SLIDE",
  ZOOM_MODAL_ZOOM_IN: "ZOOM_MODAL_ZOOM_IN",
  ZOOM_MODAL_ZOOM_OUT: "ZOOM_MODAL_ZOOM_OUT",
}

export default zoomModalConstants
